import { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
// The DevExtreme theme is imported from src/index.css
// (see src/themes/devextreme/index.css).
import "./App.css";
import "./styles/toast.css";
import "./styles/deveextremeOverRides.css";
import "react-toastify/dist/ReactToastify.css";
import SidebarMenuProvider from "contexts/SidebarMenuContext";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { ToastContainer } from "react-toastify";
import config from "devextreme/core/config";
import { useTranslation } from "react-i18next";
import { loadMessages } from "devextreme/localization";
import { locale } from "devextreme/localization";
import faMessages from "devextreme/localization/messages/fa.json";
import AppRoutes from "routes";
import { closeInitialModal } from "utils/domTools";

config({
  rtlEnabled: true,
});

function App() {
  const { t } = useTranslation();
  loadMessages(faMessages);
  locale("fa");

  useEffect(() => {
    document.title = t("samaBrand");
  }, [t]);

  useEffect(() => {
    closeInitialModal();
  }, []);

  return (
    <BrowserRouter>
      <SidebarMenuProvider>
        <AppRoutes />

        {/* --- Toast --- */}
        <ToastContainer
          toastClassName="!rounded-lg"
          progressClassName="!h-[3px] !opacity-70 !bg-mofidBlue-90"
          position="bottom-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick={false}
          rtl={true}
          pauseOnFocusLoss={false}
          draggable={false}
          toastStyle={{
            fontSize: "12px",
            lineHeight: "1.4rem",
          }}
          pauseOnHover
          closeButton={true}
          theme="light"
        />
      </SidebarMenuProvider>
    </BrowserRouter>
  );
}

export default App;
